module.exports = "https://www.gc-pro.gnp.com.mx/12be0d7b15fd89c1acdcb437dec8255b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Banner_PortalSoyCliente-06.png
// module id = 8050
// module chunks = 0